import { Modal } from "antd";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import audioDarkIcon from "../../../assets/icon/audioDarkIcon.svg";
import keyboardIcon from "../../../assets/icon/keyboardIcon.svg";
import muteDarkIcon from "../../../assets/icon/muteDarkIcon.svg";
import noVibrationIcon from "../../../assets/icon/noVibrationIcon.svg";
import noVoiceIcon from "../../../assets/icon/noVoiceIcon.svg";
import pencilIcon from "../../../assets/icon/pencilIcon.svg";
import placeholderIcon from "../../../assets/icon/placeholderIcon.png";
import speakIcon from "../../../assets/icon/speakIcon.svg";
import tapDarkIcon from "../../../assets/icon/tapDarkIcon.png";

const audioInst = [
  { img: audioDarkIcon, title: "These are spoken tests" },
  {
    img: noVoiceIcon,
    title: "Take these in a quiet and noise-free area area",
  },
  {
    img: speakIcon,
    title: "Speak loudly & clearly while recording",
  },
  {
    img: noVibrationIcon,
    title: "Don't keep phone in vibration mode",
  },
];
const nonAudioInst = [
  { img: muteDarkIcon, title: "Respond by tap-select/typing on text" },
  {
    img: pencilIcon,
    title: "Use paper & pencil if required",
  },
  {
    img: keyboardIcon,
    title: "Enter response using keyboard in some tests",
  },
  {
    img: tapDarkIcon,
    title: "Tap options via finger in some tests",
  },
];

export const AudioInst = () => {
  const audioModal = JSON.parse(localStorage.getItem("audioModal"));

  const [audioVisible, setAudioVisible] = useState(audioModal === "1");
  const handleAudioVisible = () => {
    localStorage.removeItem("audioModal");
    setAudioVisible(false);
  };

  return (
    <Modal
      visible={audioVisible}
      title="AUDIO TEST"
      className="sml-modal"
      footer={
        <div className="sml-footer">
          <button className="custom-btn ok" onClick={handleAudioVisible}>
            Ok
          </button>
        </div>
      }
    >
      <div className="modal-instructions">
        {audioInst.map((inst, index) => (
          <div className="modal-inst" key={index}>
            <div className="modal-inst-img">
              <LazyLoadImage
                placeholderSrc={placeholderIcon}
                alt=""
                effect="blur"
                src={inst.img}
              />
            </div>
            <span>{inst.title}</span>
          </div>
        ))}
      </div>
    </Modal>
  );
};
export const NonAudioInst = () => {
  const nonAudioModal = JSON.parse(localStorage.getItem("nonAudioModal"));
  const [nonAudioVisible, setNonAudioVisible] = useState(nonAudioModal === "1");

  const handleNonAudioVisible = () => {
    localStorage.removeItem("nonAudioModal");
    setNonAudioVisible(false);
  };

  return (
    <Modal
      visible={nonAudioVisible}
      title="NON-AUDIO TEST"
      className="sml-modal"
      footer={
        <div className="sml-footer">
          <button className="custom-btn ok" onClick={handleNonAudioVisible}>
            Ok
          </button>
        </div>
      }
    >
      <div className="modal-instructions">
        {nonAudioInst.map((inst, index) => (
          <div className="modal-inst" key={index}>
            <div className="modal-inst-img">
              <LazyLoadImage
                placeholderSrc={placeholderIcon}
                alt=""
                effect="blur"
                src={inst.img}
              />
            </div>
            <span>{inst.title}</span>
          </div>
        ))}
      </div>
    </Modal>
  );
};
